module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    ref: "scene",
    staticClass: "scene"
  }, [_c('canvas', {
    ref: "canvas"
  }), _vm._v(" "), _c('div', {
    staticClass: "view-buttons"
  }, [_c('div', {
    staticClass: "view-button",
    class: _vm.viewAngleIcon,
    on: {
      "click": function($event) {
        _vm.nextViewAngle()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rotate-button icon-rotate-right",
    on: {
      "mousedown": function($event) {
        _vm.startRotate(-0.01)
      },
      "mouseup": _vm.stopRotate,
      "mouseout": _vm.stopRotate
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-01ee5312!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scene.vue
// module id = 190
// module chunks = 5